<template>
  <div
    v-if="overflown"
    ref="bar"
    :class="$style.scrollbar"
    :style="barStyle"
    @click.self="handleScrollbarClick"
  >
    <div
      ref="bobber"
      :class="$style.bobber"
      :style="bobberStyle"
      @mousedown.self="handleBobberMousedown"
      @touchstart.self="handleBobberTouchstart"
    ></div>
  </div>
</template>

<script>
import ScrollbarMixin from './ScrollbarMixin';

import { SCROLLBAR_ORIENTATION_VERTICAL } from './const';

export default {
  name: 'ScrollbarVertical',
  mixins: [
    ScrollbarMixin,
  ],
  created() {
    this.$orientation = SCROLLBAR_ORIENTATION_VERTICAL;
  },
  data() {
    return {
      barStyle: {},
      bobberStyle: {
        height: 'auto',
        position: 'absolute',
        top: '0px',
      },
      clientHeight: 0,
    };
  },
  methods: {
    /**
     * Функция вычисляет, как относится длина контента элемента к длине скроллбара, так как
     * скроллбар по сути представляет собой всю длину скроллящегося контента
     */
    calcScrollModificator(scrollLength) {
      if (!this.$refs.bar) {
        return;
      }

      const { clientHeight } = this.$refs.bar;

      this.scrollModificator = scrollLength / clientHeight;
    },
    /**
     * Полученное выше значение используется, чтобы вычислить длину поплавка скроллбара, так
     * как поплавок - это длина видимой части элемента по отношению к длине всего
     * скроллящегося контента
     */
    calcBobberLength(clientLength) {
      this.clientHeight = clientLength;
      const bobberHeight = clientLength / this.scrollModificator;

      this.bobberStyle.height = `${bobberHeight}px`;
    },
    /**
     * По тому же принципу это значение используется, чтобы вычислять отступ поплавка от
     * начала скроллбара
     */
    applyBobberOffset() {
      const top = this.elementScroll / this.scrollModificator;

      this.bobberStyle.top = `${top}px`;
    },
    /**
     * Изменяет позиционирование элемента, если скроллбар находится внутри скроллящегося
     * элемента
     */
    applyBarStyle(elementScrollPrimary, elementScrollSecondary) {
      // Отнимаем единицу, иначе у родительского элемента всегда будет увеличиваться размер
      elementScrollPrimary -= 1;
      elementScrollSecondary -= 1;

      const transform = `translate(${elementScrollSecondary}px, ${elementScrollPrimary}px)`;

      // TODO: заменить на $validate из utils
      if (
        !Object
          .keys(this.barStyle)
          .some(key => Object.hasOwnProperty.call(this.barStyle, key))
      ) {
        this.barStyle = {
          transform: window.getComputedStyle(this.$refs.bar).transform,
        };

        if (this.barStyle.transform === 'none') {
          this.barStyle.transform = transform;
        } else {
          this.barStyle.transform = `${this.barStyle.transform} ${transform}`;
        }
      } else {
        this.barStyle.transform = this
          .barStyle
          .transform
          .replace(/translate\(.*\)/, transform);
      }
    },
    handleScrollbarClick(event) {
      if (this.isScrolling) {
        return;
      }

      const { offsetY } = event;
      const elementScrollYChange = (offsetY * this.scrollModificator) - this.elementScroll - (this.clientHeight / 2);

      this.$directive.applyScroll(0, elementScrollYChange);
    },
    handleBobberMousemove(event) {
      if (!this.isScrolling) {
        return;
      }

      const { clientY } = event;
      this.applyScroll(clientY);
    },
    handleBobberTouchmove(event) {
      if (!this.isScrolling) {
        return;
      }

      const { clientY } = event.changedTouches[0];
      this.applyScroll(clientY);
    },
    /**
     * Вычисляет смещение скролла и передает в директиву
     */
    applyScroll(clientY) {
      const elementScrollYChange = (clientY - this.currentScrollY) * this.scrollModificator;

      this.$directive.applyScroll(0, elementScrollYChange);
      this.currentScrollY = clientY;
    },
  },
};
</script>

<style lang="sass" module>
  .scrollbar
    width: 4px
    height: 300px
    position: relative
    background-color: #f0f0f0
    user-select: none

  .bobber
    width: 100%
    height: 10px
    position: absolute
    top: 0
    background-color: #909090
    transition: all 0.05s
</style>
